import React, { useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Checkbox, CheckboxLabel, CheckboxCount } from './styles';

interface Props {
  includedTaxes: { text: string; }[];
  values: string[];
  onChange: (values: string[]) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const IncludedTaxes = ({ includedTaxes: includedTaxes, values, onChange, onOptionChange }: Props) => {
  const { t } = useStoreTranslation();

  const isChecked = useCallback((checkValue: string) => Boolean(values.find((item) => item === checkValue)), [values]);

  const handleChange = (newValue: string) => {
    if (isChecked(newValue)) {
      onChange([...new Set(values.filter((item) => item !== newValue))]);
    } else {
      onChange([...new Set([...values, newValue])]);
    }
    if (onOptionChange) onOptionChange(newValue, !isChecked(newValue));
  };

  return (
    <section>
      {includedTaxes.map((includedTax) => {

        const label = (() => {
          switch (includedTax.text) {
            case 'yes':
              return t('hotelsCard.taxesIncluded');
            default:
              return t('hotelsCard.taxesNotIncluded');
          }
        })();

        return (
          <Checkbox key={includedTax.text} checked={isChecked(includedTax.text)} onChange={() => handleChange(includedTax.text)}>
            <CheckboxLabel content={t(label)} onClick={() => handleChange(includedTax.text)} />
            <CheckboxCount/>
          </Checkbox>
        );
      })}
    </section>
  );
};

export default IncludedTaxes;
